import { useQuery } from '@tanstack/react-query';

import { currentAccountService } from '../services/currentAccount.service';

export const useCurrentAccountJurisdiction = (accountId: string | undefined) => {
  return useQuery({
    queryKey: ['current-account-jurisdiction', accountId],
    queryFn: () => currentAccountService.getAccountJurisdiction(accountId!),
    enabled: !!accountId
  });
};
